{
	"AL": "mailto:press.europe@change.org",
	"AM": "mailto:press.europe@change.org",
	"AO": "mailto:press.europe@change.org",
	"AR": "/l/ar/p/prensa",
	"AT": "/l/de/p/presse",
	"AU": "/l/au/p/press",
	"BA": "mailto:press.europe@change.org",
	"BE": "mailto:press.europe@change.org",
	"BG": "mailto:press.europe@change.org",
	"BO": "/l/latam/p/prensa",
	"BR": "/l/br/p/imprensa",
	"BY": "/l/ru/p/страница-пресс-службы-change-org",
	"CA": "/l/ca/p/press",
	"CH": "mailto:press.europe@change.org",
	"CL": "/l/latam/p/prensa",
	"CO": "/l/latam/p/prensa",
	"CR": "/l/latam/p/prensa",
	"CU": "/l/latam/p/prensa",
	"CY": "mailto:press.europe@change.org",
	"CZ": "mailto:press.europe@change.org",
	"DE": "/l/de/p/presse",
	"DK": "mailto:press.europe@change.org",
	"DO": "/l/latam/p/prensa",
	"EC": "/l/latam/p/prensa",
	"EE": "mailto:press.europe@change.org",
	"ES": "/l/es/p/prensa",
	"FI": "mailto:press.europe@change.org",
	"FO": "mailto:press.europe@change.org",
	"FR": "/l/fr/p/presse",
	"GB": "/l/uk/p/press",
	"GE": "mailto:press.europe@change.org",
	"GI": "/l/uk/p/press",
	"GR": "mailto:press.europe@change.org",
	"GT": "/l/latam/p/prensa",
	"HN": "/l/latam/p/prensa",
	"HR": "mailto:press.europe@change.org",
	"HU": "mailto:press.europe@change.org",
	"ID": "/l/id/p/pers",
	"IE": "/l/uk/p/press",
	"IN_disabled": {
		"comment": "disabled until page is ready - rename key to 'IN' when ready",
		"url": "/l/in/p/प्रेस",
		"localesOverrides": {
			"hi-IN": "/l/in/p/प्रेस?lang=hi-IN"
		}
	},
	"IS": "mailto:press.europe@change.org",
	"IT": "/l/it/p/media",
	"JP": "/l/jp/p/pressroom_JP",
	"LU": "/l/fr/p/presse",
	"LV": "mailto:press.europe@change.org",
	"MC": "mailto:press.europe@change.org",
	"MK": "mailto:press.europe@change.org",
	"MT": "mailto:press.europe@change.org",
	"MX": "/l/mx/p/prensa",
	"NI": "/l/latam/p/prensa",
	"NL": "mailto:press.europe@change.org",
	"NO": "mailto:press.europe@change.org",
	"PA": "/l/latam/p/prensa",
	"PE": "/l/latam/p/prensa",
	"PL": "mailto:press.europe@change.org",
	"PR": "/l/latam/p/prensa",
	"PT": "mailto:press.europe@change.org",
	"PY": "/l/latam/p/prensa",
	"RO": "mailto:press.europe@change.org",
	"RU": "/l/ru/p/страница-пресс-службы-change-org",
	"SE": "mailto:press.europe@change.org",
	"SI": "mailto:press.europe@change.org",
	"SK": "mailto:press.europe@change.org",
	"SM": "mailto:press.europe@change.org",
	"SV": "/l/latam/p/prensa",
	"TR": "mailto:press.europe@change.org",
	"UA": "/l/ru/p/страница-пресс-службы-change-org",
	"US": "/l/us/p/press",
	"UY": "/l/latam/p/prensa",
	"VA": "mailto:press.europe@change.org",
	"VE": "/l/latam/p/prensa"
}
